export default __webpack_public_path__ + "static/media/project2.9e7d7070.PNG";